import React from 'react';
export function SolutionSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-258">
      <span className="inline-block bg-[var(--red)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-259">
        LA SOLUCIÓN
      </span>

      <div className="bg-[var(--card)] border border-[var(--border)] rounded-2xl p-7" data-id="element-260">
        <h2 className="text-[26px] font-extrabold" data-id="element-261">
          El Radar Invisible de{' '}
          <span className="text-[var(--red2)]" data-id="element-262">Intenciones</span>
        </h2>

        <div className="h-[3px] w-[50px] bg-[var(--accent)] my-4" data-id="element-263" />

        <p className="text-[var(--muted)] my-3.5 leading-relaxed" data-id="element-264">
          A diferencia de los libros de consejos vagos, esto es un Protocolo
          Operativo de Detección. Evalúas 20 sensores de comportamiento
          específicos.
        </p>

        <div className="flex gap-2.5 my-4" data-id="element-265">
          <button className="bg-[var(--card2)] text-white border-none rounded-full px-5 py-2.5 font-semibold text-sm" data-id="element-266">
            ✓ PASÓ
          </button>
          <button className="bg-[var(--red2)] text-white border-none rounded-full px-5 py-2.5 font-semibold text-sm" data-id="element-267">
            🔴 NO PASÓ
          </button>
        </div>

        <p className="text-white text-[15px]" data-id="element-268">
          Sin debates internos. Sin dudas.
          <br data-id="element-269" />
          <strong className="text-white" data-id="element-270">
            Los datos deciden, no tus emociones.
          </strong>
        </p>
      </div>
    </section>;
}